import { useState } from "react";
import { SurveyFormData } from "types/onboarding";

export function useSurveyForm() {
  const [formData, setFormData] = useState<SurveyFormData>({
    companyName: "",
    goals: [],
    referralSource: "",
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);

  function validate(data: SurveyFormData) {
    const next: Record<string, string> = {};

    if (!data.companyName.trim()) {
      next.companyName = "Company name is required.";
    } else if (data.companyName.trim().toLowerCase() === "sigil") {
      next.companyName =
        "That's our name! Please choose a different company name.";
    }

    if (data.goals.length === 0) next.goals = "Select at least one goal.";
    if (!data.referralSource)
      next.referralSource = "Please choose how you heard about us.";
    return next;
  }

  const clearFieldError = (key: keyof SurveyFormData) =>
    setErrors((prev) => {
      if (!prev[key]) return prev;
      const copy = { ...prev };
      delete copy[key];
      return copy;
    });

  const updateField = (
    field: keyof SurveyFormData,
    value: string | string[]
  ) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (hasAttemptedSubmit) {
      const nextErrs = validate({ ...formData, [field]: value });
      if (!(field in nextErrs)) clearFieldError(field);
      else setErrors((prev) => ({ ...prev, [field]: nextErrs[field] }));
    }
  };

  const validateForm = () => {
    setHasAttemptedSubmit(true);
    const nextErrors = validate(formData);
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const showError = (key: keyof SurveyFormData) =>
    hasAttemptedSubmit && !!errors[key];

  return {
    formData,
    errors,
    updateField,
    validateForm,
    showError,
  };
}
